import { cn } from '@/lib/utils'
import { COLORS } from '@/lib/constants'

interface LoadingProps {
  className?: string
  message?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-10 w-10',
  lg: 'h-16 w-16'
}

const messageSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base'
}

export function Loading({ className, message = 'Carregando...', size = 'md' }: LoadingProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-4', className)}>
      <div className={cn('relative', sizeClasses[size])}>
        {/* Círculo externo pulsante */}
        <div className="absolute inset-0 animate-ping rounded-full bg-primary/20" />
        
        {/* Círculo médio com fade */}
        <div className="absolute inset-0 animate-pulse rounded-full bg-primary/40" />
        
        {/* Círculo interno girando */}
        <div className="absolute inset-[2px] animate-spin rounded-full border-2 border-primary border-t-transparent" />
        
        {/* Círculo central fixo */}
        <div className="absolute inset-[4px] rounded-full bg-primary/10" />
      </div>
      
      {message && (
        <span className={cn(
          'text-muted-foreground animate-pulse',
          messageSizeClasses[size]
        )}>
          {message}
        </span>
      )}
    </div>
  )
} 